module.exports = __webpack_public_path__ + "static/assets/3ea55f6af25d3914c1049b738643d348.png";